module.exports = __webpack_public_path__ + "img/ShareIt-app.4a11b24b.svg";